import { useCallback, useState } from 'react';
import { genericUpdateError } from '../../../toaster/utils';
import { useGenericApiRequest } from '../../../common/hooks/useGenericApiRequest';
import checkValidations from '../../../common/utils/checkValidations';
import { validation } from './validation';

export default function useCreateOffer(uuid, setIsSubmitted) {
  const { loading, executeRequest } = useGenericApiRequest({
    url: `${process.env.REACT_APP_PUBLIC_API_URL}/swaps/asset/${uuid}`,
    method: 'POST',
  });
  const [errors, setErrors] = useState({
    offerDetails: '',
    name: '',
    phone: '',
  });

  const validateOffer = checkValidations(validation(), setErrors, errors);

  const createSwap = useCallback(
    formData => {
      if (
        validateOffer({ ...formData, phone: formData.phone.replace('+1', '') })
      ) {
        executeRequest()(formData)
          .then(response => {
            setIsSubmitted(true);
          })
          .catch(error => {
            genericUpdateError(`Failed to send a message about this offer.`);
            if (process.env.REACT_APP_VERBOSE === 'true') console.log(error);
          });
      }
    },
    [uuid],
  );

  return { loading, createSwap, errors };
}
